export enum UserOrganizationsActionTypes {
  GetOrganizations = 'myAccount/getOrganizations',
  GetOrganizationsSuccess = 'myAccount/getOrganizationsSuccess',
  GetOrganizationsFailed = 'myAccount/getOrganizationsFailed',
}
